"use strict";

var _defineProperty = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/defineProperty");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _reactJss = require("react-jss");

var _default = (0, _reactJss.withStyles)(function (_ref) {
  var screens = _ref.screens,
      colors = _ref.colors,
      spacing = _ref.spacing;
  return {
    root: {},
    gridList: {
      display: 'flex',
      flexWrap: 'wrap',
      margin: '0 auto',
      justifyContent: 'center',
      textAlign: 'left',
      width: 720,
      '& li': {
        marginBottom: spacing.md,
        padding: '0 12px',
        borderRight: '1px solid rgba(0,0,0,0.15)',
        '&:last-child': {
          border: '0'
        }
      }
    },
    link: _defineProperty({
      color: colors.secondaryDarkContrast,
      fontSize: 14,
      textDecoration: 'none'
    }, screens.mdUp, {
      borderBottom: '1px solid transparent',
      fontSize: 14,
      transition: 'all 0.15s linear',
      '&:hover': {
        borderColor: 'rgba(0,0,0,0.8)',
        color: 'rgba(0,0,0,0.8)'
      }
    })
  };
});

exports["default"] = _default;